









import Vue from 'vue';
import NewForm, {
  FormDataInterface,
} from '@/containers/cv-section-link/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionLinkStoreNew from '@/store/modules/cvSectionLinkNew';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    NewForm,
  },
  data() {
    return {
      section: {
        title: null,
      } as FormDataInterface,
    };
  },
  methods: {
    async onSubmit({ title }: FormDataInterface) {
      const { cv_id } = this.$route.params;
      await this.$store.dispatch(
        CvSectionLinkStoreNew.CreateCvSectionLink.namespaced({
          params: {
            cv_id,
          },
          body: {
            title,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
      this.$router.push({ name: 'cv_edit_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
